import { HttpClient,HttpBackend,HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, switchMap  } from 'rxjs';
import { map } from 'rxjs/operators'
import { EnvService } from '../../../core/env.service';
import { AuthService } from '../../../core/auth-service.component';

import { FilterIdsDto} from '../../rule.interface'


@Injectable({
    providedIn: 'root'
})
export class ValidationService {
    constructor(
        private _httpClient: HttpClient,
        public _env: EnvService,
        private _httpClientBackend: HttpClient,
        private _httpHandler: HttpBackend,
        private _authService: AuthService) {

        this._httpClientBackend = new HttpClient(_httpHandler); //using this var will now show the loader 
    }

    GetFilterByValidation(clientCode: string): Observable<any> {
        return this._httpClient.get<any>(`${this._env.apiRule}Autopass/GetFilterByValidation?clientCode=${clientCode}`).pipe(map((res: any) => res));
    }

    SearchValidation(data: any, clientCode: string): Observable<any> {
        return this._httpClient.post<any>(`${this._env.apiRule}Autopass/PostValidationSearch?clientCode=${clientCode}`, data).pipe(map((res: any) => res));
    }

    DeleteFilterIds(data: FilterIdsDto): Observable<any>{
        return this._httpClient.delete<any>(`${this._env.apiRule}Autopass/DeleteFilterIds`, { body: data }).pipe(map((res: any) => res));
    }


   
}